module.exports = __webpack_public_path__ + "img/20200104115018354.1005feb2.png";